const TEXTAREA_WAIT_TIMEOUT_MS = 3000
const TEXTAREA_POLL_INTERVAL_MS = 50

function getWidgetTextarea(widget: HTMLElement): HTMLTextAreaElement | null {
  const textarea = widget.shadowRoot?.querySelector('textarea')
  return textarea instanceof HTMLTextAreaElement ? textarea : null
}

function setTextareaValue(textarea: HTMLTextAreaElement, value: string) {
  const setter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value')?.set

  if (setter) {
    setter.call(textarea, value)
  } else {
    textarea.value = value
  }

  textarea.dispatchEvent(new Event('input', { bubbles: true, composed: true }))
  textarea.dispatchEvent(new Event('change', { bubbles: true, composed: true }))
}

async function waitForTextarea(widget: HTMLElement, timeoutMs: number) {
  const deadline = Date.now() + timeoutMs

  while (Date.now() < deadline) {
    const textarea = getWidgetTextarea(widget)
    if (textarea && !textarea.disabled) {
      return textarea
    }

    await new Promise((resolve) => window.setTimeout(resolve, TEXTAREA_POLL_INTERVAL_MS))
  }

  return null
}

export async function submitCoachGraceInitialMessage(
  widget: HTMLElement,
  message: string,
  timeoutMs = TEXTAREA_WAIT_TIMEOUT_MS,
): Promise<boolean> {
  const trimmedMessage = message.trim()
  if (!trimmedMessage) {
    return false
  }

  const textarea = await waitForTextarea(widget, timeoutMs)
  if (!textarea) {
    return false
  }

  textarea.focus()
  setTextareaValue(textarea, trimmedMessage)
  textarea.dispatchEvent(
    new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      bubbles: true,
      cancelable: true,
      composed: true,
    }),
  )

  return true
}
